<template>
  <div class="list">
    <div class="item">
      <div class="view">
        <canvas id="triangle" ref="triangle" class="canvas" width="1000" height="1000" />
      </div>
    </div>
    <div class="item">
      <div class="view">
        <canvas id="triangle2" ref="triangle2" class="canvas" width="1000" height="1000" />
      </div>
    </div>
  </div>
</template>

<script>
import Triangle from '@/modules/day6-triangle'

const colorArray = {
  'blue': ['#111111', '#222222', '#333333', '#444444', '#555555', '#666666'],
  'event': ['#F5F5F5', '#EEEEEE', '#E0E0E0', '#BDBDBD', '#9E9E9E', '#757575']
}

export default {
  name: 'Day6',
  data: () => ({
    triangle: false,
    triangle2: false
  }),
  beforeDestroy() {
    if (this.triangle) {
      this.triangle.stop()
    }
    if (this.triangle2) {
      this.triangle2.stop()
    }
  },
  mounted() {
    const el = this.$refs.triangle
    const el2 = this.$refs.triangle2
    this.triangle = new Triangle(el, {
      colors: colorArray['blue'],
      hankei: [4, 6]
    })
    this.triangle2 = new Triangle(el2, {
      colors: colorArray['event'],
      hankei: [4, 6]
    })
  }
}
</script>

<style scoped lang="scss">
.view {
  @include FR_FULLSIZE;
  overflow: hidden;
}
.canvas {
  @include FR_FULLSIZE;
}
</style>
